import React from 'react';
import { useNavigate } from 'react-router';
import { CandidatesConst } from '@axiom/const';
import { Gutter, Tabs, TabsItem, useApi } from '@axiom/ui';

import { CandidateApi } from '../../api/candidate-api';
import { FeatureVisibilityUtil } from '../../utils/feature-visibility-util';
import { CandidateEngagementsApi } from '../../api/candidate-engagements-api';
import { useCandidateId } from '../../hooks/useCandidateId';

export type EngagementsTabName =
  'ENGAGEMENTS_TAB' | 'OPPORTUNITY_FEED_TAB' | 'HISTORY_TAB';
export type EngagementsTabNavigationProps = {
  pathToEngagements: string;
  startTab: EngagementsTabName;
};

export const EngagementsTabNavigation: React.FC<
  EngagementsTabNavigationProps
> = ({ pathToEngagements, startTab }) => {
  const navigate = useNavigate();
  const candidateId = useCandidateId();

  const [{ data: candidate }, { data: counts }] = useApi(
    CandidateApi.readCandidate(candidateId),
    CandidateEngagementsApi.readEngagementsCount(candidateId)
  );

  return (
    <Gutter bottom="16px">
      <Tabs name="ENGAGEMENTS_TAB_NAVIGATION" startTab={startTab}>
        <TabsItem
          countBadge={counts.engagements}
          label="Engagements"
          name="ENGAGEMENTS_TAB"
          onClick={() => {
            void navigate(pathToEngagements);
          }}
        >
          {null}
        </TabsItem>
        {!FeatureVisibilityUtil.shouldSeeLimitedFeatureSetBasedOnProfileStatus(
          candidate
        ) &&
        candidate.employeeType &&
        candidate.employeeType !== CandidatesConst.EmployeeTypes.Contractor ? (
          <TabsItem
            label="Opportunity Feed"
            name="OPPORTUNITY_FEED_TAB"
            onClick={() => {
              void navigate(`${pathToEngagements}/opportunity-feed/all`);
            }}
          >
            {null}
          </TabsItem>
        ) : null}
        {counts.pastInterestHistoryTotal +
          counts.pastSubmissionHistoryTotal +
          counts.pastEngagementHistoryTotal >
        0 ? (
          <TabsItem
            countBadge={
              counts.pastEngagementHistory +
              counts.pastInterestHistory +
              counts.pastSubmissionHistory
            }
            label="History"
            name="HISTORY_TAB"
            onClick={() => {
              void CandidateEngagementsApi.refreshEngagementsHistory(
                candidateId
              );
              void CandidateEngagementsApi.refreshEngagementsCount(candidateId);
              void navigate(`${pathToEngagements}/history`);
            }}
          >
            {null}
          </TabsItem>
        ) : null}
      </Tabs>
    </Gutter>
  );
};
